import { donationConstants } from '../actions/constants/donationConstants';

const initialState = {	
	isError: false,
	isUserDonationsLoaded: false,
	userdonationData: [],
	isUserRecurringDonationsLoaded: false,
	userRecurringdonationData: []
}


const donationData = (state = initialState, action: any) => {
	switch (action.type) {
		case donationConstants.DonationGetByFilterRequest:
			return {
				...state,
				isUserDonationsLoaded: false
			};
		case donationConstants.DonationGetByFilterSuccess:
			return {
				...state,
				status: action.payload.status,
				userdonationData: action.payload.stripeDonations,
				isSuccess: true,
				isUserDonationsLoaded: true
			};
		case donationConstants.DonationGetByFilterFailure:
			return {
				...state,
				error: action.payload,
				isError: true,
				isUserDonationsLoaded: false
			};

		case donationConstants.DonationRecurringGetByFilterRequest:
			return {
				...state,
				isUserRecurringDonationsLoaded: false
			};
		case donationConstants.DonationRecurringGetByFilterSuccess:
			return {
				...state,
				status: action.payload.status,
				userRecurringdonationData: action.payload.donations,
				isSuccess: true,
				isUserRecurringDonationsLoaded: true
			};
		case donationConstants.DonationRecurringGetByFilterFailure:
			return {
				...state,
				error: action.payload,
				isError: true,
				isUserRecurringDonationsLoaded: false
			};
		default:
			return state;
	}
};

export default donationData;
